import React from 'react'

export default function RecentVideo() {
  return (
    <div>RecentVideo</div>
  )
}
